import { createAppLogging } from "@bindery/logging/client/app-logging";
import { LOG_SERVICE_NAME } from "../site";
import { storageKey } from "../storage";
import { REDACTED_ROUTES } from "./redactedRoutes";

const appVersion: unknown = import.meta.env.VITE_APP_VERSION;

export const appLogging = createAppLogging({
  serviceName: LOG_SERVICE_NAME,
  storageKey,
  redactedRoutes: REDACTED_ROUTES,
  environment: {
    mode: import.meta.env.MODE,
    appVersion,
    // Exact match: any non-empty string is truthy, so `VITE_LOG_DEBUG=false` would otherwise enable debug.
    debug: import.meta.env.VITE_LOG_DEBUG === "true",
    readBackendSetting: (): unknown => import.meta.env.VITE_LOG_BACKEND,
  },
});
